//separate buttons
import React from 'react'
import { StyleSheet, View } from 'react-native'

import { DS } from '@/design-system'

import * as cth from '@/router/(root)/cth/cthModule'
import * as d10 from '@/router/(root)/daily10/d10Module'
import * as pocketPick from '@/router/(root)/pocketPick/pocketPickModule'

import { PrimaryBtn} from "@/components/Mini/Button"
import { SecondaryBtn } from "@/components/Mini/Button"

import type { MinigameModule } from '@/types/minigameModule'

function CthFooter(){

  return (
    <Footer m={cth} />
  )
}

function PocketPickFooter(){

  return (
    <Footer m={pocketPick} />
  )
}

function D10Footer(){

  return (
    <Footer m={d10} allowPlayAgainBtn={false} checkHasDeal={false} />
  )
}

type FooterProps = {
    m: MinigameModule
    allowResultsBtn?: boolean
    allowPlayAgainBtn?: boolean
    checkHasDeal?: boolean
  }

function Footer({m, allowResultsBtn=true, allowPlayAgainBtn=true, checkHasDeal=true}: FooterProps) {

  const { status } = m.useQueryStatus()

  const theme = m.useStore(s => s.theme);
  const textColor = theme.textDefault
  
  const showUnavailableMsg = (status?.status === 'available') && (checkHasDeal ? !('hasDeal' in status && status.hasDeal) : false)
  const showPlayBtn = (status?.status === 'available') && (checkHasDeal ? ('hasDeal' in status && status.hasDeal) : true)
  const showResumeBtn = status?.status === 'in_progress'
  const showResultsBtn = allowResultsBtn && (status?.status === 'completed')
  const showReplayBtn = allowPlayAgainBtn && (status?.status === 'completed')

  return (
    <View style={styles.footer}>
      {showUnavailableMsg && (
        <DS.Text variant="Body Large/Regular" style={[styles.centeredText, {color: textColor}]} textAlign="center">
          Today's deal is not ready yet. Check back soon.
        </DS.Text>
      )}
      {showPlayBtn &&
        <PlayBtn m={m}/>
      }
      {showResumeBtn &&
        <ResumeBtn m={m}/>
      }
      {showResultsBtn &&
        <ResultsBtn m={m}/>
      }
      {showReplayBtn && (
        <ReplayBtn m={m}/>
      )}
    </View>
  )
}

function PlayBtn({m}: { m: MinigameModule }) {

   const handlePlay = m.useHandlePlay()
   const theme = m.useStore(s => s.theme)

   return (
    <PrimaryBtn theme={theme} handler={handlePlay} label="Play Today's Game" />
   )
}

function ResumeBtn({m}: { m: MinigameModule }) {
  
   const handlePlay = m.useHandlePlay()
   const theme = m.useStore(s => s.theme)

   return (
    <PrimaryBtn theme={theme} handler={handlePlay} label="Resume" />
   )
}

function ResultsBtn({m}: { m: MinigameModule }) {
  
   const handleResults = m.useHandleResults()
   const theme = m.useStore(s => s.theme)

   return (
    <PrimaryBtn theme={theme} handler={handleResults} label="See Results" />
   )
}

function ReplayBtn({m}: { m: MinigameModule }) {
  
   const handlePlay = m.useHandlePlay()
   const theme = m.useStore(s => s.theme)

   return (
    <SecondaryBtn theme={theme} handler={handlePlay} label="Play again (unscored)" />
   )
}

const styles = StyleSheet.create({
 // fill: { flex: 1 },
 // body: { flex: 1, paddingHorizontal: 24, justifyContent: 'center', gap: 40 },
  centeredText: { textAlign: "center" },
  footer: { paddingHorizontal: 24, paddingBottom: 16, gap: 12 }
})

export { Footer, CthFooter, D10Footer, PocketPickFooter }
